import { render, staticRenderFns } from "./UpdateVariableModal.vue?vue&type=template&id=52b3ccbc"
import script from "./UpdateVariableModal.vue?vue&type=script&lang=js"
export * from "./UpdateVariableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports